import { Injectable } from '@angular/core';
import {
  AbstractControlOptions,
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { UtilsService } from '@app/providers/utils/utils.service';
import * as _ from 'lodash';
import { Subject } from 'rxjs';
import { EaEstimationFormService } from '../ea-estimation-form/ea-estimation-form.service';
import { EaFeesFormService } from '../ea-fees-form/ea-fees-form.service';

@Injectable({
  providedIn: 'root',
})
export class EaRealestateFormService {
  constructor(
    protected formBuilder: UntypedFormBuilder,
    protected utilsService: UtilsService,
    protected eaEstimationFormService: EaEstimationFormService,
    protected eaFeesFormService: EaFeesFormService,
  ) {}
  generateSubject: Subject<UntypedFormGroup> = new Subject();
  options;

  public generate(entity: any) {
    this.options = entity;
    let mainAddress: any = {};
    if (entity.property) mainAddress = entity.property;

    let group = this.formBuilder.group({
      purchasePrice: [
        entity ? entity.purchasePrice : null,
        Validators.required,
      ],
      label: [entity ? entity.label : null, Validators.required],
      startDate: [entity ? entity.startDate : null, Validators.required],
      /* subscriptionSource: [entity ? entity.subscriptionSource : null, Validators.required],
      subscriptionSourceDetail: [entity ? entity.subscriptionSourceDetail : null, Validators.nullValidator],
      owners: [entity && entity.owners?.length ? entity.owners.map(o => o.ownerId) : null, Validators.required],*/
      areaSize: [entity ? mainAddress.areaSize : null, Validators.required],
      //residenceType: [entity && mainAddress?.type ? mainAddress.type : 'APPARTMENT', Validators.required],
      address: this.formBuilder.group({
        street: [mainAddress ? mainAddress.street : null, Validators.required],
        zipCode: [
          mainAddress ? mainAddress.zipCode : 0,
          Validators.nullValidator,
        ],
        city: [mainAddress ? mainAddress.city : null, Validators.required],
        country: [
          mainAddress ? mainAddress.country : null,
          Validators.required,
        ],
      }),
    });

    this.generateSubject.next(group);

    return group;
  }

  public extract(form: UntypedFormGroup, nestedForms?) {
    let dto = {
      label: this.utilsService.emptyIsNull(form.value.label),
      purchasePrice: this.utilsService.emptyIsNull(form.value.purchasePrice),
      startDate: this.utilsService.toIsoDate(form.value.startDate),
      // subscriptionSource: this.utilsService.emptyIsNull(form.value.subscriptionSource),
      // subscriptionSourceDetail: this.utilsService.emptyIsNull(form.value.subscriptionSourceDetail),
      property: {
        type: this.utilsService.emptyIsNull(form.value.residenceType),
        areaSize: this.utilsService.emptyIsNull(form.value.areaSize),
        street: this.utilsService.emptyIsNull(
          form.controls.address.get('street').value,
        ),
        zipCode: this.utilsService.emptyIsNull(
          form.controls.address.get('zipCode').value,
        ),
        city: this.utilsService.emptyIsNull(
          form.controls.address.get('city').value,
        ),
        country: this.utilsService.emptyIsNull(
          form.controls.address.get('country').value,
        ),
      },
      // owners: _.map(this.utilsService.emptyIsNull(form.value.owners), (owner) => { return { ownerId: owner } }),
    };
    return dto;
  }
}
